<template>
  <div :class="{
      'element-wrapper loader-wrapper': !encontrado,
      'element-wrapper': encontrado,
    }"
  >
  <LoaderComponent :condicion="encontrado" />
  <div class="content-box" v-if="encontrado">
      <div class="element-box">
        <div class="container-fluid py-4">
          <div class="row mb-4 g-0 w-100">
            <div class="col-6 d-flex justify-content-start">
              <router-link
                class="btn btn-default"
                :to="{ name: 'cat-terminal-pos', params: {} }"
              >
                <i class="fas fa-arrow-left"></i>
                Volver al Listado
              </router-link>
            </div>
            <div class="col-6 d-flex justify-content-end">
              <div class="btn-group">
                <button aria-expanded="false" aria-haspopup="true" class="btn btn-outline-secondary dropdown-toggle"
                  data-toggle="dropdown" type="button">
                  <i class="fa fa-cogs"></i>
                  Acciones
                </button>
                <div class="dropdown-menu dropdown-menu-right">
                  <button class="dropdown-item" v-if="current.estado !== '9'"
                    href="#" type="button" @click="desactivarTerminal()">
                    <i class="fa fa-trash"></i>
                    Desactivar
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="form-buttons-w"></div>
          <div class="row mb-4">
            <div class="col-12">
              <h3 class="text-secondary font-weight-normal mb-1">Terminal POS
                <div class="badge" :class="{
                  'badge-success': current.estado == 'A',
                  'badge-blue': current.estado == 'B',
                  'badge-danger': current.estado == '9',
                }">
                  <span v-if="current.estado_str">
                    {{ current.estado_str }}
                  </span>
                </div>
              </h3>
              <p class="text-muted small">Edición de una terminal POS para cobros de tarjeta</p>
            </div>
          </div>
          <div class="row mb-4">
            <div class="col-md-2 form-group">
              <label class="text-muted small font-weight-bold">Terminal ID</label>
              <input type="text" class="form-control  border-success" v-model="current.terminal_id" readonly disabled>
            </div>
            <div class="col-md-10 form-group">
              <label class="text-muted small font-weight-bold">Afiliación de Tienda</label>
              <input type="text" class="form-control" v-model="afiliacion" readonly disabled>
            </div>
          </div>

          <ul class="nav nav-tabs" id="terminalTabs" role="tablist">
            <li class="nav-item">
              <a class="nav-link active" id="general-tab" data-toggle="tab" href="#general" role="tab">Información
                General</a>
            </li>

            <li class="nav-item">
              <a class="nav-link" id="cajas-tab" data-toggle="tab" href="#cajas" role="tab">Cajas Asignadas</a>
            </li>
          </ul>

          <div class="tab-content" id="terminalTabsContent">

            <div class="tab-pane fade show active pt-4" id="general" role="tabpanel" aria-labelledby="general-tab">
              <div class="row">

                <div class="col-md-6">
                  <div class="form-group row mb-3">
                    <label class="col-12 text-muted small">Modelo</label>
                    <div class="col-12">
                      <input type="text" class="form-control text-muted" v-model="current.modelo" readonly disabled>
                    </div>
                  </div>

                  <div class="form-group row mb-3">
                    <label class="col-12 text-muted small">IMEI</label>
                    <div class="col-12">
                      <input type="text" class="form-control text-muted" v-model="current.imei" readonly disabled>
                    </div>
                  </div>

                  <div class="form-group row mb-3">
                    <label class="col-12 text-muted small">Número de Serie</label>
                    <div class="col-12">
                      <input type="text" class="form-control text-muted" v-model="current.numero_serie" readonly disabled>
                    </div>
                  </div>

                  <div class="form-group row mb-3">
                    <label class="col-12 text-muted small">Tipo de POS</label>
                    <div class="col-12">
                      <input type="text" class="form-control text-muted" v-model="current.tipo_pos_obj.descripcion" readonly disabled>
                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group row mb-3">
                    <label class="col-12 text-muted small">IP</label>
                    <div class="col-12">
                      <input type="text" class="form-control text-muted" v-model="current.ip" readonly disabled>
                    </div>
                  </div>

                  <div class="form-group row mb-3">
                    <label class="col-12 text-muted small">Fecha de Creación</label>
                    <div class="col-6">
                      <input type="text" class="form-control text-muted" v-model="fecha_creacion.fecha" readonly disabled>
                    </div>
                    <div class="col-6">
                      <input type="text" class="form-control text-muted" v-model="fecha_creacion.hora" readonly disabled>
                    </div>
                  </div>

                  <div class="form-group row mb-4">
                    <label class="col-12 text-muted small">Tipo de Cobro</label>
                    <div class="col-12">
                      <input type="email" class="form-control text-muted" v-model="current.tipos_cobro_obj.descripcion" readonly disabled>
                    </div>
                  </div>
                </div>

              </div>
              <div class="form-buttons-w">
                <button v-if="current.estado !== '9'" class="btn btn-primary" @click="abrirModalEditarTerminal()">
                  Editar
                </button>
              </div>
            </div>

            <div class="tab-pane fade pt-4" id="cajas" role="tabpanel" aria-labelledby="cajas-tab">
              <div class="row">
                <div class="col-12">
                  <p class="text-muted small">Administración de cajas registradoras asignadas a esta terminal.</p>
                  <div class="tab-pane fade pt-4" id="cajas" role="tabpanel" aria-labelledby="cajas-tab">
                    <div class="row">
                      <div class="col-12">

                        <div class="d-flex justify-content-end mb-3">
                          <button type="button" class="btn btn-sm btn-outline-success px-3" @click="abrirModalAgregar">
                            <i class="fa fa-plus-circle mr-1"></i> Asignar Caja
                          </button>
                        </div>

                        <div class="table-responsive">
                          <table class="table table-striped table-hover table-bordered text-secondary">
                            <thead class="bg-light text-muted">
                              <tr>
                                <th style="font-weight: 600;" class="small">CAJA</th>
                                <th style="font-weight: 600;" class="small">TIENDA</th>
                                <th style="width: 12%; font-weight: 600;" class="small class text-center">ACCIONES</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="item in current.cajas_asignadas" :key="item.id">
                                <td class="align-middle">{{ item.caja.numero }}</td>
                                <td class="align-middle">{{ item.tienda.codigo }}-{{ item.tienda.nombre }}</td>
                                <td class="text-center align-middle">
                                  <button type="button" class="btn btn-sm btn-outline-danger border-0"
                                    title="Quitar asignación" @click="confirmarQuitarCaja(item)">
                                    <i class="fa fa-trash-o"></i> Quitar
                                  </button>
                                </td>
                              </tr>

                              <tr v-if="current.cajas_asignadas.length === 0">
                                <td colspan="4" class="text-center text-muted py-4 small">
                                  No hay cajas asignadas a esta terminal.
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="modalAgregarCajas" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-sm modal-dialog-centered" role="document">
        <div class="modal-content">
          
          <div class="modal-header border-0 pb-0">
            <h5 class="modal-title text-secondary font-weight-normal">Asignar Cajas</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body py-3">
            <p class="text-muted small mb-3">Selecciona los números de caja a asociar:</p>
            <div class="border rounded bg-light px-3 py-2" style="max-height: 220px; overflow-y: auto;">
              
              <div 
                class="py-2 border-bottom" 
                v-for="caja in cajasDisponiblesParaAsignar" 
                :key="caja.id"
              >
                <div class="form-check">
                  <label class="form-check-label">
                    <input 
                      @change="actualizarSeleccionados()"
                      type="checkbox"
                      class="form-check-input" 
                      :value="caja.id"
                      v-model="cajasSeleccionadasIdsTemp"
                    >Caja #{{ caja.caja }} - {{ caja.id }}
                  </label>
                </div>
              </div>

              <div v-if="cajasDisponiblesParaAsignar.length === 0" class="text-center text-muted small py-3">
                No hay más cajas disponibles.
              </div>

            </div>
          </div>

          <div class="modal-footer border-0 pt-0">
            <button type="button" class="btn btn-sm btn-light text-muted px-3" data-dismiss="modal">Cancelar</button>
            <button 
              type="button" 
              class="btn btn-sm btn-success px-3" 
              :disabled="cajasSeleccionadasIds.length === 0"
              @click="guardarNuevasAsignaciones"
            >
              Asociar ({{ cajasSeleccionadasIds.length }})
            </button>
          </div>

        </div>
      </div>
    </div>
    <div class="modal fade" id="modalQuitarCaja" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header border-0 pb-0">
            <h5 class="modal-title text-secondary font-weight-normal">Quitar Asignación</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body py-3" v-if="cajaSeleccionada && cajaSeleccionada.caja">
            ¿Está seguro de que desea remover la terminal {{ current.terminal_id }} de la
            tienda <strong>{{ cajaSeleccionada.caja.id }}-{{ cajaSeleccionada.caja.numero }}</strong> ?
          </div>
          <div class="modal-body py-3" v-else>No se ha seleccionado ninguna caja a desasignar.</div>
          <div class="modal-footer border-0 pt-0">
            <button type="button" class="btn btn-sm btn-light text-muted px-3"
              data-dismiss="modal">Cancelar</button>
            <button type="button" class="btn btn-sm btn-danger px-3"
              @click="quitarCaja">Confirmar</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="modalEditarTerminal" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
          
          <div class="modal-header border-0 pb-0">
            <h5 class="modal-title text-secondary font-weight-normal">Editar Datos de Terminal</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body py-3">
            <div class="row">
              
              <div class="col-md-6">
                <div class="form-group mb-3">
                  <label class="text-muted small font-weight-bold">ID Terminal</label>
                  <input 
                    type="text" 
                    class="form-control bg-light text-muted" 
                    v-model="terminalForm.terminal_id"
                  >
                </div>

                <div class="form-group mb-3">
                  <label class="text-muted small font-weight-bold">Modelo</label>
                  <input 
                    type="text" 
                    class="form-control text-secondary" 
                    v-model="terminalForm.modelo" 
                    placeholder="Ej. PAX A77"
                  >
                </div>

                <div class="form-group mb-3">
                  <label class="text-muted small font-weight-bold">IMEI</label>
                  <input 
                    type="text" 
                    class="form-control text-secondary" 
                    v-model="terminalForm.imei" 
                    placeholder="Ingrese el IMEI"
                  >
                </div>

                <div class="form-group mb-3">
                  <label class="text-muted small font-weight-bold">Número de Serie</label>
                  <input 
                    type="text" 
                    class="form-control text-secondary" 
                    v-model="terminalForm.numero_serie" 
                    placeholder="Ingrese número de serie"
                  >
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group mb-3">
                  <label class="text-muted small font-weight-bold">Tipo POS</label>
                  <select class="form-control text-secondary" v-model="terminalForm.tipo_pos">
                    <option readonly>Seleccione tipo...</option>
                    <option v-for="tipo in tipos_pos" :value="tipo.llave">{{tipo.valor}}</option>
                  </select>
                </div>

                <div class="form-group mb-3">
                  <label class="text-muted small font-weight-bold">Tipo de Cobro</label>
                  <select class="form-control text-secondary" v-model="terminalForm.tipos_cobro">
                    <option readonly>Seleccione tipo cobro...</option>
                    <option v-for="tipo in tipos_cobro" :value="tipo.llave">{{ tipo.valor }}</option>
                  </select>
                </div>

                <div class="form-group mb-3">
                  <label class="text-muted small font-weight-bold">Dirección IP</label>
                  <input 
                    type="text" 
                    class="form-control text-secondary" 
                    v-model="terminalForm.ip" 
                    placeholder="Ej. 192.168.1.50"
                  >
                </div>
              </div>

            </div>
          </div>

          <div class="modal-footer border-0 pt-0">
            <button type="button" class="btn btn-sm btn-light text-muted px-3" data-dismiss="modal">Cancelar</button>
            <button 
              type="button" 
              class="btn btn-sm btn-success px-4" 
              @click="actualizarTerminal"
            >
              Guardar Cambios
            </button>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoaderComponent from "@/components/commons/LoaderComponent";
import TerminalPOSService from "@/services/catalogos/TerminalPOSService";
import CajaService from "@/services/cxc/CajaService";
import Notifications from "@/notifications/notifications";
import { parsearFechaHoraString } from "@/utils";
export default {
  components: {
    LoaderComponent
  },
  data() {
    return {
      current: {},
      // Catálogo global con todos los números de caja existentes en esta terminal/sucursal
      catalogoCajasGeneral: ['1', '2', '3', '4', '5', '6', '7', '8'],

      // Aquí se guardan únicamente los IDs/números seleccionados en los checks (ej: ['2', '3'])
      cajasSeleccionadasIdsTemp: [],
      cajasSeleccionadasIds: [],
      cajaSeleccionada: {},
      encontrado: false,
      terminalForm: {
        id: '',
        terminal_id: '',
        modelo: '',
        imei: '',
        numero_serie: '',
        tipos_pos: '',
        tipo_cobro: '',
        ip: '',
      },
      tipos_cobro:[],
      tipos_pos:[],
    }
  },
  computed: {
    afiliacion() {
      if(!this.encontrado) return "";
      return`${this.current.numero_afiliacion_tienda} - ${this.current.afiliacion_tienda_obj.proveedor.nombre} en tienda (${this.current.afiliacion_tienda_obj.tienda.codigo})${this.current.afiliacion_tienda_obj.tienda.nombre}`;
    },
    fecha_creacion() {
      return parsearFechaHoraString(this.current.fecha_creacion);
    },
    cajasDisponiblesParaAsignar() {
      if (!this.encontrado) return [];
      return this.catalogoCajasGeneral.filter(caja => {
        return !this.current.cajas_asignadas.some(cajaAsignada => cajaAsignada.caja.id === caja.id);
      });
    },
  },
  mounted() {
    if (this.$route.params.id) {
      this.refreshCurrent();
    }
  },
  methods: {
    refreshCurrent() {
      this.encontrado = false;
      TerminalPOSService.getById(this.$route.params.id)
        .then(response => {
          this.current = response.data;
          this.obtenerCajasTienda();
          this.encontrado = true;
        })
        .catch(error => {
          this.$toast.error("No se pudo encontrar la terminal seleccionada.", "Error", {
            position: 'topRight'
          });
          this.$router.push({
            name: "cat-terminal-pos",
            params: { },
          });
        });
    },
    obtenerCajasTienda(){
      CajaService.fetch({
        tienda: this.current.afiliacion_tienda_obj.tienda.codigo,
        quitar_paginacion: true,
      })
      .then(response => {
        this.catalogoCajasGeneral = response.data;
      })
    },
    abrirModalAgregar() {
      this.cajasSeleccionadasIds = []; // Limpia la selección previa
      $('#modalAgregarCajas').modal('show');
    },
    confirmarQuitarCaja(item) {
      this.cajaSeleccionada = item;
      // Desencadena el modal nativo de Bootstrap
      $('#modalQuitarCaja').modal('show');
    },
    quitarCaja() {
      if (this.cajaSeleccionada) {
        let params = {
          caja:this.cajaSeleccionada.id
        }
        TerminalPOSService.quitarCaja(this.current.id,params)
        .then(response => {
          this.$toast.success(response.data.detail,"Éxito",  {
            position: 'topRight'
          });
          this.cajaSeleccionada = null;
          this.cajasSeleccionadasIdsTemp= [];
          this.actualizarSeleccionados();
          $('#modalQuitarCaja').modal('hide');
          this.refreshCurrent();
        })
      }
    },
    actualizarSeleccionados(){
      this.cajasSeleccionadasIds = this.cajasSeleccionadasIdsTemp;
    },
    obtenerTiposCobro() {
      TerminalPOSService.obtenerTiposCobro()
       .then(response => {
        this.tipos_cobro = response.data;
        console.log(this.tipos_cobro);
      });
    },
    obtenerTiposPOS(){
      TerminalPOSService.obtenerTiposPOS()
       .then(response => {
          this.tipos_pos = response.data;
          console.log(this.tipos_pos);
        });
    },
    guardarNuevasAsignaciones(){
      let params = {
        cajas: this.cajasSeleccionadasIds,
        tienda: this.current.afiliacion_tienda_obj.tienda.codigo,
      }

      TerminalPOSService.asignarCajas(this.current.id, params)
      .then(response => {
        this.$toast.success( response.data.detail, "Éxito",{
          position: 'topRight'
        });
        this.cajasSeleccionadasIdsTemp = [];
        this.cajaSeleccionada = null;
        this.actualizarSeleccionados();
        $('#modalAgregarCajas').modal('hide');
        this.refreshCurrent();
      })
    },
    actualizarFormularioUpdate() {
      // Se limpia el formulario para evitar que siga con los valores anteriores
      this.terminalForm.id="";
      this.terminalForm.terminal_id="";
      this.terminalForm.modelo="";
      this.terminalForm.imei="";
      this.terminalForm.numero_serie="";
      this.terminalForm.tipo_pos="";
      this.terminalForm.tipos_cobro="";
      this.terminalForm.ip="";
      
      // Clonamos el objeto para romper la referencia reactiva de la tabla mientras edita
      this.terminalForm.id = String(this.current.id).replaceAll("-", "");
      this.terminalForm.terminal_id=this.current.terminal_id;
      this.terminalForm.modelo=this.current.modelo;
      this.terminalForm.imei=this.current.imei;
      this.terminalForm.numero_serie=this.current.numero_serie;
      this.terminalForm.tipo_pos=this.current.tipo_pos;
      this.terminalForm.tipos_cobro=this.current.tipos_cobro;
      this.terminalForm.ip=this.current.ip;
    },
    // Llama a esta función desde el botón "Editar" de tu tabla pasando el objeto completo de la terminal
    abrirModalEditarTerminal() {
      this.actualizarFormularioUpdate();
      console.log("Objeto terminal a editar:", this.terminalForm);
      
      this.obtenerTiposPOS();
      this.obtenerTiposCobro();

      // Desencadena el modal nativo de Bootstrap
      $('#modalEditarTerminal').modal('show');
    },
    actualizarTerminal() {
      // Aquí tienes el objeto modificado y listo con los tipos correctos para enviar a tu API
      const payload = { ...this.terminalForm };
      
      console.log("Payload para actualizar terminal en backend:", payload);

      TerminalPOSService.update(this.current.id, payload)
      .then(response => {
        this.$toast.success( response.data.detail, "Éxito",{
          position: 'topRight'
        });
        this.refreshCurrent();
      })

      // Tras el éxito del servicio, puedes proceder a cerrar el modal
      $('#modalEditarTerminal').modal('hide');
      
      // Ejemplo de cómo refrescar tu lista local o invocar tu método de carga habitual:
      // this.obtenerTerminales();
    },
    desactivarTerminal(){
      TerminalPOSService.desactivar(this.current.id)
      .then(response => {
        this.$toast.success( response.data.detail, "Éxito",{
          position: 'topRight'
        });
        this.refreshCurrent();
      })
    },
  },
}
</script>

<style scoped>
/* Ajustes para igualar la sutileza de los bordes y textos de la imagen */
.form-control::placeholder {
  color: #a0a0a0;
  font-weight: 300;
}

.form-control {
  border-color: #ced4da;
  color: #495057;
}

.nav-tabs .nav-link {
  color: #6c757d;
}

.nav-tabs .nav-link.active {
  color: #28a745;
  /* Color verde de enfoque para la pestaña activa */
  border-bottom-color: #28a745;
}
</style>